import type { FormControl } from '@angular/forms';
import type { PhoneVerificationRequestTypeApi } from 'api-typings/users/users';

export enum SetupSecurityPhoneModalState {
  PENDING,
  REQUEST_CHANGE,
  SETUP,
}

export enum SetupSecurityPhoneStatus {
  CANCELLED,
  SUCCESS,
}

export interface PhoneVerificationInputForm {
  country: FormControl<string>;
  phoneNumber: FormControl<string>;
  verificationMethod: FormControl<PhoneVerificationRequestTypeApi>;
  captcha?: FormControl<string>;
}
